/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports
import { jsx } from '@emotion/react';

import { expandIconContainerStyle } from '@atlaskit/editor-common/styles/expand';
import {
	triggerWrapperStylesWithPadding,
	disableBlueBorderStyles,
} from '@atlaskit/editor-common/styles/plugins';
import ToolbarButton from '@atlaskit/editor-common/ui-menu/ToolbarButton';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ItalicIcon from '@atlaskit/icon/core/text-italic';

import { ToolbarType } from './types';

type DropdownButtonProps = {
	activeIconName?: string;
	'aria-expanded': React.AriaAttributes['aria-expanded'];
	iconBefore?: React.ReactElement;
	isDisabled: boolean;
	isReducedSpacing: boolean;
	isSelected: boolean;
	label: string;
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
	onKeyDown?: (event: React.KeyboardEvent) => void;
	toolbarType: ToolbarType;
};

export const DropdownToolbarButton = ({
	label,
	isReducedSpacing,
	isDisabled,
	isSelected,
	'aria-expanded': ariaExpanded,
	onClick,
	onKeyDown,
	toolbarType,
	iconBefore,
	activeIconName,
}: DropdownButtonProps): jsx.JSX.Element => {
	const reducedSpacing = toolbarType === ToolbarType.FLOATING ? 'compact' : 'none';

	return (
		<ToolbarButton
			// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
			css={disableBlueBorderStyles}
			testId={'ak-editor-selection-toolbar-format-text-button'}
			spacing={isReducedSpacing ? reducedSpacing : 'default'}
			disabled={isDisabled}
			selected={isSelected}
			aria-label={label}
			aria-expanded={ariaExpanded}
			aria-haspopup
			title={label}
			onClick={onClick}
			onKeyDown={onKeyDown}
			iconBefore={
				<div
					css={
						// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
						triggerWrapperStylesWithPadding
					}
					data-testid={activeIconName ? `editor-toolbar__${activeIconName}` : undefined}
				>
					{iconBefore ? (
						iconBefore
					) : (
						<ItalicIcon color="currentColor" spacing="spacious" label="" />
					)}
					{/* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values */}
					<span css={expandIconContainerStyle}>
						<ChevronDownIcon label="" color="currentColor" size="small" />
					</span>
				</div>
			}
		/>
	);
};
